// src/components/ChargingStation/hooks/useStripeMobile.web.ts

/**
 * Stub for Web: no native payment sheet,
 * so just no-ops.
 */
export function useStripeMobile() {
  return {
    paymentSheetOrder: null,
    openPaymentSheet: async () => {
      // no-op on web
    },
  };
}